import { render, staticRenderFns } from "./RecommendedList.vue?vue&type=template&id=191a2367&scoped=true&"
import script from "./RecommendedList.vue?vue&type=script&lang=js&"
export * from "./RecommendedList.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedList.vue?vue&type=style&index=0&id=191a2367&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191a2367",
  null
  
)

export default component.exports